import React, { memo, useState, useEffect } from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { Button } from '../../../components/Button';
import { Card } from '../../../components/Card';

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    toolbar: {},
    editorWrapper: {
      maxHeight: 'calc(100% - 44px)',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    editor: {
      flexGrow: 1,
    },
  });
};
interface IHelpSettingsView extends WithStyles<typeof styles> {
  settings: any;
  handleUpdateSettings: (data: any) => void;
}

const HelpSettingsView: React.FC<IHelpSettingsView> = ({
  classes,
  settings,
  handleUpdateSettings,
}: IHelpSettingsView) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const intl = useIntl();

  useEffect(() => {
    if (settings?.data?.help) {
      const helpSetting = EditorState.createWithContent(
        convertFromRaw(JSON.parse(settings?.data?.help))
      );

      setEditorState(helpSetting);
    }
  }, [settings.data]);

  const _onEditorStateChange = (value: any) => {
    setEditorState(value);
  };

  const _handlePublishButtonClick = () => {
    const help = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
    const data = {
      setting: { help },
      category: 'help',
    };
    handleUpdateSettings(data);
  };
  return (
    <Card customStyles={classes.root}>
      <Editor
        editorState={editorState}
        toolbarClassName={classes.toolbar}
        wrapperClassName={classes.editorWrapper}
        editorClassName={classes.editor}
        onEditorStateChange={_onEditorStateChange}
      />
      <Button
        color="primary"
        variant="contained"
        id="help-publish-button"
        label={intl.formatMessage({
          id: 'publish',
        })}
        onClick={_handlePublishButtonClick}
      />
    </Card>
  );
};

export default memo(withStyles(styles)(HelpSettingsView));
